/**
 * @module app.shared
 */
import { bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { NumberInputBase } from 'app/shared/elements/forms/number-input-base';

@bindable({ name: 'value', defaultBindingMode: bindingMode.twoWay })
@bindable.numberNull({ name: 'min' })
@bindable.numberNull({ name: 'max' })
@bindable.numberNull({ name: 'step' })
@bindable.numberNull({ name: 'precision' })
@bindable.stringNull({ name: 'label' })
@bindable.stringNull({ name: 'placeholder' })
@bindable.stringNull({ name: 'icon' })
@bindable.booleanAttr({ name: 'required' })
@bindable.booleanAttr({ name: 'readonly' })
@bindable.booleanAttr({ name: 'disabled' })
@bindable.stringNull({ name: 'autocomplete' })
@bindable.stringNull({ name: 'testName' })
@bindable.stringNull({ name: 'testPrefix' })
@bindable.stringNull({ name: 'requiredValidatorLabel' })
@bindable.stringNull({ name: 'labelledbyId' })
export class EssNumberCustomElement extends NumberInputBase { }
